import { ESectionTrackStatus } from '@constants';
import { ISectionsStudyStatus, IBasicSubscription } from '@sdk/contracts';
import { useMemo } from 'react';

import { SectionTrackingSelector } from '@/components/Form';
import { useMutateMySubscriptions, useProfile } from '@/store';

type Props = {
  section: ISectionsStudyStatus;
  selectedSubscription: IBasicSubscription;
};

export const SectionStatus: React.FC<Props> = ({ section, selectedSubscription }) => {
  const { isWorking, updateSectionTrack } = useMutateMySubscriptions();
  const {
    roleCheck: { isTeacher }
  } = useProfile();

  const sectionTracking = useMemo(
    () => selectedSubscription?.sectionTracking.find(st => st.section === section.sectionId),
    [selectedSubscription]
  );

  if (!selectedSubscription) return null;

  return (
    <SectionTrackingSelector
      disabled={isTeacher}
      isLoading={isWorking}
      value={sectionTracking?.status}
      onChange={(newStatus: ESectionTrackStatus) =>
        updateSectionTrack({
          subscriptionId: selectedSubscription._id,
          sectionTrack: {
            section: section.sectionId,
            status: newStatus
          }
        })
      }
    />
  );
};
